import React from 'react'
import ActionPanel from '../ActionPanel/ActionPanel'
import {Link} from 'react-router-dom'
import library from '../../../global-style/library.module.css'
import {classList} from '@peachy/utility-kit-pure'

export type FeelingPeachyProps = {
    className?: string
}

export default function FeelingPeachy({className}: FeelingPeachyProps) {
    return (
        <ActionPanel className={className}>
            <h1>Feeling Peachy?</h1>
            <p>Simple, digital health insurance you can trust. That's just Peachy.</p>
            <nav>
                <Link className={classList(library.button, library.buttonBordered)} to={'/register-interest'}>Interested?</Link>
                <Link className={classList(library.button, library.buttonBordered)} to={'/how-it-works'}>How it works</Link>
            </nav>
        </ActionPanel>
    )
}
